const INFO = {
	main: {
		title: "Sivakorn Wongponkanan",
		name: "Sivakorn Wongponkanan",
		email: "mail@sivakorn.koto@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/Thanatossan",
		linkedin: "https://www.linkedin.com/in/sivakorn-wongponkanan-9322b520b",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Hi, I’m Sivakorn",
		description:
			"I am a software engineer with 5+ years worth of development, Proven experience in design, developement, management, testing, scalable architecture, and team leadership.",
	},

	about: {
		title: "I’m Sivakorn Wongponkanan.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	websiteProjects: [
		{
			title: "MotalVip",
			description:
				"A website for MotalVip, a platform for buying and selling for phone store. It features a user-friendly interface and secure payment options.",
			img: "./image/motalvip.jpg",
			logo: "react.svg",
			linkText: "View Website",
			link: "https://www.motalvip.com/",
			facebookLink: "https://www.facebook.com/profile.php?id=61575936646184",
		},
		{
			title: "TakoTask",
			description:
				"TakoTask is a task management application that helps users organize and prioritize their tasks effectively. It features a clean and intuitive interface, making it easy to use.",
			img: "./image/takotask.png",
			logo: "vue.svg",
			linkText: "View Landing Page",
			link: "https://www.takotask.com/",
			facebookLink: "https://www.facebook.com/takotask",
		},
		{
			title: "Skill Mapping for Life Long Learning",
			description:
				"A career advisory website that provides personalized skill mapping for users based on their skills and interests. It helps users identify potential career paths and learning opportunities.",
			img: "./image/mapping.png",
			logo: "react.svg",
			linkText: "View Website",
			link: "https://skillsync.cpe.eng.cmu.ac.th/",
		},
	],

	projects: [
		{
			title: "myAIS",
			description:
				"Mobile application for AIS customer, I have developed this application using Flutter and Bloc State Management.",
			img: "flutter.svg",
			logo: "./icon/my_ais_ic_launcher.png",
			linkText: "View on App Store",
			link: "https://apps.apple.com/th/app/myais/id399758084",
		},
		{
			title: "FutureSkill - for Business",
			description:
				"Learning Application that I have design structure using clean Architecture and Bloc State management.",
			img: "flutter.svg",
			logo: "./icon/b2b.webp",
			linkText: "View on App Store",
			link: "https://play.google.com/store/apps/details?id=com.likemex.business.futureskill&hl=en",
		},

		{
			title: "FutureSkill - UpSkill Now",
			img: "",
			description:
				"Learning Application that I have design structure using clean Architecture and Bloc State management.",
			logo: "./icon/b2c.webp",
			linkText: "View on App Store",
			link: "https://apps.apple.com/th/app/futureskill-upskill-now/id6468992311",
		},

		{
			title: "Mandala: Drone Portal",
			description:
				"Drone Management Application using Stacked as State Management",
			logo: "./icon/mandala.webp",
			linkText: "View on App Store",
			link: "https://play.google.com/store/apps/details?id=com.arv.dronevidya.mandala&hl=en",
		},

		{
			title: "AiANG DRONE",
			description:
				"Agriculture Drone Control Application, exclusive only android. I have development additional feature and improve performance",
			logo: "./icon/aiang.webp",
			linkText: "View on Play Store",
			link: "https://play.google.com/store/apps/details/AiANG_DRONE?id=com.aiangdrone&hl=th",
		},

		{
			title: "Weight Balance CMU",
			description:
				"Cross-platform mobile application, communicate to hardware-device by bluetooth. This application aim on help patient that have balancing problem",
			logo:  "./icon/wb.png",
			linkText: "View News",
			link: "https://www.cmu.ac.th/th/article/e8db7536-e0ac-4761-8b35-eb808a1e3183",
		},
		{
			title: "Bachelor Degree Final Project",
			description:
				"Hand-Signed Language translator, this also have machine learning model to classified and translate hand-signed language ",
			logo: "flutter.svg",
			linkText: "View Final Project",
			link: "https://project.cpe.eng.cmu.ac.th/492/poster/600610772-2563_2thai_sign_language_translation_system_in_mobile_application.pdf",
		},
	],
	sideProject: [
		{
			title: "Master Degree Thesis",
			description:
				"Automatic Exudate Segmentation of Diabetic Retinopathy in Digital Fundus Images, using image processing technique to capture and segment exudate (lipid-area) area from eye ball",
			logo: "file-type-matlab.svg",
			linkText: "View Thesis",
			link: "https://cmudc.library.cmu.ac.th/frontend/Info/item/dc:181837",
		},
		{
			title: "Winner of E-initiative Hackathon",
			description:
				"Winner of E-initiative Hackathon under topic `Change role, Change form, Make it easy with e-Initiative`",
			logo: "vue.svg",
			linkText: "View website",
			link: "https://www.cpe.eng.cmu.ac.th/content-thaiview.php?view_id=HACKATHON-CPE2020",
		},
		{
			title: "BMEI Photometer Sensor Control Application",
			description:
				"Python Applcation control photometric device using PyQT as interface",
			logo: "python.svg",
			linkText: "",
			link: "https://github.com",
		},

		{
			title: "3D Dental Manipulator Application",
			description:
				"Implement 3D visualize and manipulate model for 3Dprinting",
			logo: "python.svg",
			linkText: "",
			link: "https://github.com",
		},

		{
			title: "JhanglekGames 30th live score summary Website",
			description:
				"Implement summary website in 30th of JhanglekGames Website",
			logo: "vue.svg",
			linkText: "View Project",
			link: "https://thirsty-liskov-0f5b8b.netlify.app/",
		},
	],

	activities: [
		{
			title: "Conference Speaker",
			description: "Presented at tech conferences about mobile development and Flutter",
			img: "activity/ac1.jpg",
			date: "2024",
			category: "Speaking"
		},
		{
			title: "FutureSkill Development",
			description: "Led development team for FutureSkill learning platform",
			img: "activity/ac5.jpg",
			date: "2023",
			category: "Leadership"
		},
		{
			title: "Hackathon Winner",
			description: "Winner of E-initiative Hackathon - Change role, Change form, Make it easy with e-Initiative",
			img: "activity/ac3.jpg",
			date: "2020",
			category: "Achievement"
		},
		{
			title: "FutureSkill Development",
			description: "Led development team for FutureSkill learning platform",
			img: "activity/ac4.jpg",
			date: "2023",
			category: "Leadership"
		}
	],
};

export default INFO;
